import { PageBase } from '../PageBase';
import SignUpCode from '../signUp/signUpCode/SignUpCode';
import { useState } from 'react';
import { UserDTO } from '@/data/DTOs/UserDTO';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { styles } from './styles';

export const CodeWrapper = () => {
  const [loading, setLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const location = useLocation();
  const { locationEmail } = location.state || {};
  const navigate = useNavigate();
  const { t } = useTranslation(['forgot_password', 'signInCode']);
  const user: UserDTO = {
    id: '',
    name: '',
    surname: '',
    birthDate: '',
    gender: '',
    email: locationEmail,
    phone: '',
    countryCode: '',
    zip: '',
    address: '',
    password: '',
    complement: undefined,
    city: undefined,
    state: undefined,
    picture: undefined,
  };

  return (
    <PageBase
      title={t('resend_code_title')}
      onBackClick={() => navigate(-1)}
      sxContainer={styles.minContainer}
      sxContentBox={styles.minContent}
    >
      <Typography sx={styles.text}>
        {t('signInCode:create_account_step_4_subtitle')}
      </Typography>
      <SignUpCode
        changeStep={() => navigate('/', { state: { showSuccessCode: true } })}
        user={user}
        setUser={() => {}}
        loading={loading}
        setLoading={setLoading}
        showWarning={showWarning}
        setShowWarning={setShowWarning}
        warningMessage={warningMessage}
        setWarningMessage={setWarningMessage}
        forceResend
      />
    </PageBase>
  );
};
